import React from "react";
import { Button } from 'primereact/button';
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { Editor } from "primereact/editor";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { Checkbox } from "primereact/checkbox";

import { FormSectionElements, RedirectSection } from "../../entities/formTemplateDataType";
import { getRootComponent } from "../../utilities/ElementUtils";

interface Props {
	ele: FormSectionElements;
	dialogVisible: boolean;
	isEng: boolean;
	callback;
}
interface State {
	statusCodeError?: string;
	statusCodeValue?: string;
	redirectPage?: RedirectSection;
}

export class DialogForOrderConfirmationComponent extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = {
		};
		this.props.ele.input = {...this.props.ele.input ?? {}, submitCollect: this.props.ele.input?.submitCollect ?? true};
	}

	componentDidMount(): void {
	}

	generateHtmlString = () => {
		let html = [];
		html.push(
			<>
				<Dialog header={this.props.isEng ? "Field Properties for " + this.props.ele.ENUTitle : "Field Properties for " + this.props.ele.FRATitle} footer={this.renderFooter()}
					visible={this.props.dialogVisible} style={{ width: '50vw' }} contentStyle={{ maxHeight: '70vh', overflow: 'auto' }} onHide={() => this.props.callback(false)}>
					{this.orderConfirmationHtml()}
				</Dialog>
			</>
		);
		return html;
	}

	generateSectionIndex = (element: FormSectionElements) => {
		const root = getRootComponent(element);
		const index = root.ListOfFormSections.map(section => {
				return {sequence: section.Sequence, title: section.ENUTitle };
		});
		return index;
	};

	handleStatusCodeChange = (e) => {
        const regex = /^[a-zA-Z0-9_-]+$/;
		const value = e.target.value as string;
		if (!value) {
				this.setState({ statusCodeError: "Status code is required" });
		} else if (!regex.test(value)) {
            this.setState({ statusCodeError: "Only alphanumeric is allowed" });
		} else {
				this.setState({ statusCodeError: undefined, statusCodeValue: value });
		}
	}

	addRoutingPage = (e) => {
		e.preventDefault();
		if (this.state.statusCodeValue && this.state.redirectPage?.redirectPage) {
				const statusCode = this.state.statusCodeValue?.trim();
				this.setState({statusCodeError: undefined});
				const route = this.state.redirectPage;
				route.statusCode = statusCode;
				this.props.ele.SubmitButton = this.props.ele.SubmitButton || {};
				this.props.ele.SubmitButton.apiSuccessRedirectPage = this.props.ele.SubmitButton.apiSuccessRedirectPage || [];
				this.props.ele.SubmitButton.apiSuccessRedirectPage.push(route);
				this.setState({statusCodeValue: undefined, redirectPage: undefined});
				this.props.callback();
		} else {
						this.setState({statusCodeError: "status code is required"});
		}			
	}

	orderConfirmationHtml = () => {
		const sectionIndex = this.generateSectionIndex(this.props.ele);

		let htmlString = [];
		htmlString.push(
			<div>
				<div style={{ display: "flex", marginTop: '10px' }}>
					<div style={{ width: '25%' }}>Script</div>
					<div style={{ width: '60%' }}>
						<InputTextarea className="ontario-input" value={this.props.ele.Script} onChange={(e)=> { this.props.ele.Script = e.target.value; this.props.callback(); }}>
						</InputTextarea>
					</div>
				</div>
				<div style={{ display: "flex", marginTop: '10px' }}>
					<div style={{ width: '25%' }}>Callout Box Title</div>
					<div style={{ width: '60%' }}>
							<InputText className="ontario-input" value={this.props.isEng?this.props.ele.callOutBoxTitle:this.props.ele.callOutBoxTitleFRA} onChange={(e)=> { if (this.props.isEng) this.props.ele.callOutBoxTitle = e.target.value; else this.props.ele.callOutBoxTitleFRA = e.target.value; this.props.callback(); }}>
							</InputText>
					</div>
				</div>
				<div style={{ display: "flex", marginTop: '10px' }}>
					<div style={{ width: '25%' }}>Callout Box Body Message</div>
					<div style={{ width: '60%' }}>
							<Editor className="ontario-input" value={this.props.isEng ? this.props.ele.callOutBoxBody : this.props.ele.callOutBoxBodyFRA} onTextChange={(e)=> { if (this.props.isEng) this.props.ele.callOutBoxBody = e.htmlValue; else this.props.ele.callOutBoxBodyFRA = e.htmlValue; this.props.callback(); }}>
							</Editor>
					</div>
				</div>
				 <div style={{ display: "flex", marginTop: '10px' }}>
					<div style={{ width: '25%' }}>Show Order-Info section</div>
					<div style={{ width: '60%' }}>
						<Checkbox value={this.props.ele.showOrderInfoSection} 
							id={"showOrderInfoSection_" + this.props.ele.Sequence}
							onChange={(e) => { this.props.ele.showOrderInfoSection = e.checked; this.props.callback() }} 
							checked={this.props.ele.showOrderInfoSection}
						/>
			     	</div>
				 </div>
				{this.props.ele.showOrderInfoSection && <div style={{ display: "flex", marginTop: '10px', marginBottom: '20px' }}>
					<div style={{ width: '25%' }}>
							<label htmlFor={"back_button_url"}>Order-Info section title</label>
					</div>
					<div style={{ width: '60%' }}>
						<InputText key={"back_button_url"} value={this.props.isEng ? this.props.ele.OrderBreakdownConfig?.productSectionTitle: this.props.ele.OrderBreakdownConfig?.productSectionTitleFRA} className="ontario-input"
							onChange={(e) => {
								if (this.props.ele.OrderBreakdownConfig) {
									if (this.props.isEng) {
										this.props.ele.OrderBreakdownConfig = {...this.props.ele.OrderBreakdownConfig, productSectionTitle: e.target.value};
									} else {
										this.props.ele.OrderBreakdownConfig = {...this.props.ele.OrderBreakdownConfig, productSectionTitleFRA: e.target.value};
									}
								} else {
									if (this.props.isEng) {
										this.props.ele.OrderBreakdownConfig = {productSectionTitle: e.target.value};
									} else {
										this.props.ele.OrderBreakdownConfig = {productSectionTitleFRA: e.target.value};
									}
								}
								this.props.callback();
							}} 
						/>
					</div>
				</div>}
				<div style={{ display: "flex", marginTop: '10px', marginBottom: '20px' }}>
					<div style={{ width: '25%' }}>
							<label htmlFor={"back_button_url"}>Back button Url</label>
					</div>
					<div style={{ width: '60%' }}>
							<InputText key={"back_button_url"} value={this.props.ele.PCLookupUrl} className="ontario-input"
									onChange={(e) => { this.props.ele.PCLookupUrl = e.target.value; this.props.callback() }} />
					</div>
				</div>
				<div style={{ display: "flex", marginTop: '10px' }}>
					<div style={{ width: '25%' }}>Back button Label</div>
					<div style={{ width: '60%' }}>
						<InputText key={"TooltipENU" + this.props.ele.Sequence} className="ontario-input" value={this.props.isEng ? this.props.ele.TooltipENU : this.props.ele.TooltipFRA} onChange={(e) => {
							if (this.props.isEng) {
									this.props.ele.TooltipENU = e.target.value;
							} else {
									this.props.ele.TooltipFRA = e.target.value;
							}
							this.props.callback();
						}}/>
					</div>
				</div>
				<div style={{ display: "flex", marginTop: '10px' }}>
					<div style={{ width: '25%' }}>Alert Message</div>
					<div style={{ width: '60%' }}>
						<InputText className="ontario-input" value={this.props.isEng? this.props.ele.EmptyErrorMessage:this.props.ele.EmptyErrorMessageFRA} onChange={(e)=> { if (this.props.isEng) this.props.ele.EmptyErrorMessage = e.target.value; else this.props.ele.EmptyErrorMessageFRA=e.target.value; this.props.callback(); }}/>
					</div>
				</div>
				<div style={{ display: "flex", marginTop: '10px' }}>
					<div style={{ width: '25%' }}>Keep original confirmation URL</div>
					<div style={{ width: '60%' }}>
						{/* @ts-ignore */}
						<Checkbox value={this.props.ele.disableConfirmationUrlRewrite} 
							id={"disableConfirmationUrlRewrite_" + this.props.ele.Sequence}
							onChange={(e) => { this.props.ele.disableConfirmationUrlRewrite = e.checked; this.props.callback() }} 
							checked={!!this.props.ele.disableConfirmationUrlRewrite}
						/>
			     	</div>
				 </div>
				<div style={{ display: "flex", marginTop: '10px' }}>
					<div style={{ width: '25%' }}>Confirmation Title</div>
					<div style={{ width: '60%' }}>
						<InputText className="ontario-input" value={this.props.isEng ? this.props.ele.confirmationTitle : this.props.ele.confirmationTitleFRA} placeholder={this.props.isEng ? "e.g. Your complaint has been successfully submitted" : ""} onChange={(e)=> { if (this.props.isEng) this.props.ele.confirmationTitle = e.target.value; else this.props.ele.confirmationTitleFRA = e.target.value; this.props.callback(); }}/>
					</div>
				</div>
				 <div style={{ display: "flex", marginTop: '10px' }}>
					<div style={{ width: '25%' }}>Don't display "My transactions" link in confirmation message</div>
					<div style={{ width: '60%' }}>
						{/* @ts-ignore */}
						<Checkbox value={this.props.ele.noMyTransactionsLink} 
							id={"noMyTransactionsLink_" + this.props.ele.Sequence}
							onChange={(e) => { this.props.ele.noMyTransactionsLink = e.checked; this.props.callback() }} 
							checked={this.props.ele.noMyTransactionsLink}
						/>
			     	</div>
				 </div>

				<div style={{ display: "flex", marginTop: '10px' }}>
					<div style={{ width: '25%' }}>Order ID Label</div>
					<div style={{ width: '60%' }}>
						<InputText className="ontario-input" value={this.props.isEng ? this.props.ele.orderIdLabel : this.props.ele.orderIdLabelFRA} placeholder={this.props.isEng ? "Order ID" : "Numéro de commande"} onChange={(e)=> { if (this.props.isEng) this.props.ele.orderIdLabel = e.target.value; else this.props.ele.orderIdLabelFRA = e.target.value; this.props.callback(); }}/>
					</div>
				</div>	
				<div style={{ display: "flex", marginTop: '10px' }}>
					<div style={{ width: '25%' }}>Order Date Label</div>
					<div style={{ width: '60%' }}>
						<InputText className="ontario-input" value={this.props.isEng ? this.props.ele.orderDateLabel : this.props.ele.orderDateLabelFRA}  onChange={(e)=> { if (this.props.isEng) this.props.ele.orderDateLabel = e.target.value; else this.props.ele.orderDateLabelFRA = e.target.value; this.props.callback(); }}/>
					</div>
				</div>		
				<div style={{ display: "flex", marginTop: '10px' }}>
					<div style={{ width: '25%' }}>Confirmation Description</div>
					<div style={{ width: '60%' }}>
						{/* <InputText className="ontario-input" value={this.props.isEng ? this.props.ele.confirmationTitle : this.props.ele.confirmationTitleFRA} placeholder={this.props.isEng ? "e.g. Your complaint has been successfully submitted" : ""} onChange={(e)=> { if (this.props.isEng) this.props.ele.confirmationTitle = e.target.value; else this.props.ele.confirmationTitleFRA = e.target.value; this.props.callback(); }}/> */}
					     <Editor key={"ErrorMessage" + this.props.ele.Sequence}
							className="ontario-input"
							value={this.props.isEng ? this.props.ele.confirmationDescription : this.props.ele.confirmationDescriptionFRA}
							onTextChange={(e) => {
								if (this.props.isEng) {
										this.props.ele.confirmationDescription = e.htmlValue;
								} else {
										this.props.ele.confirmationDescriptionFRA = e.htmlValue;
								}

								this.props.callback();
							}}/>
					</div>
				</div>	
				<div style={{ display: "flex", marginTop: '10px' }}>
					<div style={{ width: '25%' }}>Download PDF button text</div>
					<div style={{ width: '60%' }}>
						<InputText className="ontario-input" value={this.props.isEng ? this.props.ele.downloadPDFButtonLabel : this.props.ele.downloadPDFButtonLabelFRA} placeholder={this.props.isEng ? "Download PDF confirmation" : "Télécharger la confirmation PDF"} onChange={(e)=> { if (this.props.isEng) this.props.ele.downloadPDFButtonLabel = e.target.value; else this.props.ele.downloadPDFButtonLabelFRA = e.target.value; this.props.callback(); }}/>
					</div>
				</div>	
				<div style={{ display: "flex", marginTop: '10px' }}>
					<div style={{ width: '25%' }}>Download PDF URL</div>
					<div style={{ width: '60%' }}>
						<InputText className="ontario-input" value={this.props.isEng ? this.props.ele.downloadPDFURL : this.props.ele.downloadPDFURLFRA}  title="Download PDF URL" 
						onChange={(e)=> { if (this.props.isEng) this.props.ele.downloadPDFURL= e.target.value; else this.props.ele.downloadPDFURLFRA = e.target.value; this.props.callback(); }}/>
					</div>
				</div>	
				{(this.props.ele.downloadPDFURL || this.props.ele.downloadPDFURLFRA) && (
					<div style={{ display: "flex", marginTop: '10px' }}>
						<div style={{ width: '25%' }}>API-Key:</div>
						<div style={{ width: '60%', marginTop: '5px' }}>
							<div >
									<InputText className="ontario-input"
													value={this.props.ele.downloadPDFApiKeyKey}
													placeholder="Key"
													title="API-Key Key"
													onChange={(e) => {
														this.props.ele.downloadPDFApiKeyKey = e.target.value;
														this.props.callback();
													}}
									/>
							</div>
							<div>
									<InputText className="ontario-input"
													value={this.props.ele.downloadPDFApiKeyValue}
													placeholder="Value"
													title="API-Key Value"
													onChange={(e) => {
														this.props.ele.downloadPDFApiKeyValue = e.target.value;
														this.props.callback();
													}}
									/>
							</div>
						</div>
					</div>
				)}
					
				<div style={{ display: "flex", marginTop: '10px' }}>
					<div style={{ width: '25%' }}>To do next Rich Text Message</div>
					<div style={{ width: '60%' }}>
						<Editor key={"ErrorMessage" + this.props.ele.Sequence}
							className="ontario-input"
							value={this.props.isEng ? this.props.ele.ErrorMessageRichText : this.props.ele.ErrorMessageRichTextFRA}
							onTextChange={(e) => {
								if (this.props.isEng) {
										this.props.ele.ErrorMessageRichText = e.htmlValue;
								} else {
										this.props.ele.ErrorMessageRichTextFRA = e.htmlValue;
								}

								this.props.callback();
							}}/>
					</div>
				</div>
				{/* Email field Checkbox: Display Email Field at Bottom for both Logged-In and Guest Users;
				***only display this checkbox if the 'showEmailField' is not set to 'hidden' */}
				{this.props.ele.showEmailField !== 'hidden' && (	
					<div style={{ display: "flex", marginTop: '20px', borderTop: '1px solid #ccc', paddingTop: '15px' }}>
						<div style={{ width: '25%' }}>Display Email Field at Bottom for Logged-In and Guest Users</div>
							<div style={{ width: '60%' }}>
								<Checkbox value={this.props.ele.displayEmailFieldForAllUsersAtBottom} 
									id={"emailFieldCheckbox_" + this.props.ele.Sequence}
									onChange={(e) => { this.props.ele.displayEmailFieldForAllUsersAtBottom = e.checked; this.props.callback() }} 
									checked={this.props.ele.displayEmailFieldForAllUsersAtBottom}
								/>
							</div>
					</div>	
				)}		

				<div style={{ display: "flex", marginTop: '10px' }}>			
					<div style={{ width: '25%' }}>Email Field (Guest Only)</div>
					<div style={{ width: '60%' }}>
						<Dropdown
							value={this.props.ele.showEmailField || 'hidden'}
							options={[
								{ label: 'Hidden', value: 'hidden' },
								{ label: 'Optional', value: 'optional' },
								{ label: 'Required', value: 'required' }
							]}
							onChange={(e) => { this.props.ele.showEmailField = e.value; this.props.callback(); }}
							placeholder="Select visibility"
						/>
					</div>
				</div>
				<div style={{ display: "flex", marginTop: '10px' }}>
					<div style={{ width: '25%' }}>Email Field Title</div>
					<div style={{ width: '60%' }}>
						<InputText className="ontario-input" value={this.props.isEng ? this.props.ele.emailFieldTitle : this.props.ele.emailFieldTitleFRA} placeholder={this.props.isEng ? "Send confirmation to this email address (optional):" : "Envoyer la confirmation à cette adresse courriel (facultatif) :"} onChange={(e)=> { if (this.props.isEng) this.props.ele.emailFieldTitle = e.target.value; else this.props.ele.emailFieldTitleFRA = e.target.value; this.props.callback(); }}/>
					</div>
				</div>
				<div style={{ display: "flex", marginTop: '10px' }}>
					<div style={{ width: '25%' }}>Email Field Description</div>
					<div style={{ width: '60%' }}>
						<InputText className="ontario-input" value={this.props.isEng ? this.props.ele.emailFieldDescription : this.props.ele.emailFieldDescriptionFRA} placeholder={this.props.isEng ? "Your email address will only be used to send you a transaction confirmation and will not be retained." : "Votre adresse courriel ne servira qu'à vous envoyer une confirmation de transaction et ne sera pas conservée."} onChange={(e)=> { if (this.props.isEng) this.props.ele.emailFieldDescription = e.target.value; else this.props.ele.emailFieldDescriptionFRA = e.target.value; this.props.callback(); }}/>
					</div>
				</div>
				<div style={{ display: "flex", marginTop: '10px' }}>
					<div style={{ width: '25%' }}>Email Send API</div>
					<div style={{ width: '60%' }}>
						<InputText className="ontario-input" value={this.props.ele.emailSendApi} placeholder="API endpoint for sending confirmation email" onChange={(e)=> { this.props.ele.emailSendApi = e.target.value; this.props.callback(); }}/>
					</div>
				</div>

				{/* Checkbox to send all payload if 'emailSendApi' is not null */}
				{this.props.ele.emailSendApi != null && (
					<>
						<div style={{ display: "flex", marginTop: '10px' }}>		
							<div style={{ width: '25%' }}>Send all Payload</div>
							<div style={{ width: '60%' }}>
								<Checkbox value={this.props.ele.sendWholeContainerAsPayload} 
									id={"sendPayloadCheckbox_" + this.props.ele.Sequence}
									onChange={(e) => { this.props.ele.sendWholeContainerAsPayload = e.checked; this.props.callback() }} 
									checked={this.props.ele.sendWholeContainerAsPayload}
								/>
							</div>
						</div>
						<div style={{ display: "flex", marginTop: '10px' }}>		
							<div style={{ width: '25%' }}>Enable Recaptcha</div>
							<div style={{ alignItems: 'center', marginTop: '5px' }}>
								<Checkbox checked={!!this.props.ele.Recaptcha || this.props.ele.SubmitButton?.enableRecaptcha} value={!!this.props.ele.Recaptcha}
									className='p-checkbox' title="Enable Recaptcha"
									onChange={(e) => {
										this.props.ele.Recaptcha = e.checked ? {action: ''} : undefined;
										this.props.ele.SubmitButton = {...this.props.ele.SubmitButton ?? {}, enableRecaptcha: e.checked ? e.checked : false };
										this.props.callback();
									}} />
							</div>
						</div>
					</>
				)}			
			</div>
		)
		return htmlString;
	}

	renderFooter = () => {
		return (
			<div>
				<Button label="OK" icon="pi pi-check" onClick={() => {
					this.props.callback(false);
				}} />
				<Button label="Cancel" onClick={() => { this.props.callback(false) }}/>
			</div>
		);
	}

	render() {
		return (
			this.generateHtmlString()
		)
	}
}
